type Connection<T> = { edges: Array<{ node: T }> };

/**
 * Helper function to quickly extract a connection's nodes
 */
export default function pluckNodes<T>(connection: Connection<T>) {
  return connection.edges.map((e) => e.node);
}
